export default {
  events: {
    items: {
      eventId: {
        'ui:widget': 'EditorEventWidget',
      },
    },
  },
}
